import { Injectable } from '@angular/core';
import { Requestor } from '@openid/appauth';
import { CapacitorHttp, HttpResponse } from '@capacitor/core';
import { XhrSettings } from 'ionic-appauth/lib/cordova';

@Injectable({
  providedIn: 'root',
})
export class NgHttpService implements Requestor {
  constructor() {}

  public async xhr<T>(settings: XhrSettings): Promise<T> {
    const response: HttpResponse = await CapacitorHttp.request({
      method: settings.method ?? 'GET',
      url: settings.url,
      headers: settings.headers,
      data: settings.data,
    });
    return response.data as T;
  }
}
